import React, {Fragment} from 'react'
import List from '../../../../components/Project/Resources/InService/List'
import InSeviceModal from '../../../../components/Project/Resources/InService/InSeviceModal'

function InService(props) {
  return (
    <Fragment>
      <InSeviceModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

InService.propTypes = {}
InService.defaultProps = {}

export default InService
